import React, { useState, useEffect } from "react";
import '../../Responsive.css'
import PurchaseForm from "./New_Purchase_Request";
import All_Purchase_Requests from "./All_requests";
import { host, Host } from '../../App';
import Axios from 'axios'

const Purchase_dashboard = () => {
  const [animation, setAnimation] = useState(true);
  var userName = (window.localStorage.getItem("Name").replace(/[{""}]/g, ""));
  const [Area, setArea] = useState("");
  var Stage = (window.localStorage.getItem("Stage"));
  const [rank_stage, setrank_stage] = useState(false);
  var Ranked = (window.localStorage.getItem("Rank"));
  const [mold_list, setmold_list] = useState(false);
  const [New_Request, setNew_Request] = useState(false);
  const [All_Request, setAll_Request] = useState(false);
  const [newrequests, setnewrequests] = useState([]);
  const [awaitingorder, setawaitingorder] = useState([]);
  var token = (window.localStorage.getItem("acessToken"));

  const queryParams = {
    token: token,
  };
  useEffect(() => {
    Axios.get(`https://` + Host + `/Purchase_Requisitions/newrequests`, { params: queryParams })
      .then((data) => {
        setnewrequests(data.data);
      })
  }, []);
  useEffect(() => {
    Axios.get(`https://` + Host + `/Purchase_Requisitions/awaitingorder`, { params: queryParams })
      .then((data) => {
        setawaitingorder(data.data);
      })
  }, []);
  useEffect(() => {
    if (Area == "NEW PURCHASE REQUEST") {
      setmold_list(false);
      setAnimation(false);
      setAll_Request(false);
      setNew_Request(true);
    } if (Area == "ALL REQUESTS") {
      setmold_list(false);
      setAnimation(false);
      setNew_Request(false);
      setAll_Request(true);
    } if (Area == "DAILY PURCHASE REPORT") {
      setmold_list(false);
      setAnimation(false);
      setNew_Request(true);
      setAll_Request(false);
    } if (Area == "PURCHASE REPORTS") {
      setmold_list(false);
      setAnimation(false);
      setNew_Request(false);
      setAll_Request(true);
    }
  }, [Area]);
  const handleSelect = (selectedArea) => {
    setArea(selectedArea);
  };

  useEffect(() => {
    if (Ranked === '"Admin"' && Stage === '"2"') {
      setrank_stage(true);
    }
  }, [Ranked]);

  return (
    <div class="row" id="main-row">
      <div class="row" id="header-row-production">
        <div id="sidebar-col" >
          <div id="sidebar">
            <ul id="sidebar-nav">
              <li class="nav-item" id="nav-item-1" style={{ background: "#2B6532", padding: "0px 150px" }} onClick={() => handleSelect('NEW PURCHASE REQUEST')}>
                <span>New Purchase Request</span>
              </li>
              <li class="nav-item" id="nav-item-1" style={{ background: "#2B6532", padding: "0px 150px" }} onClick={() => handleSelect('ALL REQUESTS')}>
                <span>All Requests</span>
              </li>

            </ul>
          </div>
        </div>
      </div>

      <br />
      <div class="row" id="header-row">
        <div class="col-2" id="header-col-1"></div>
        <div class="col-2" id="header-col-2"></div>
        <div class="col-2" id="header-col-3"></div>
        <div class="col-4" id="header-col-4"></div>
        <div id="user-name-block" class="col-2">
          <span class="user-name">{userName}</span>
        </div>
      </div>
      <h1 id="area-title" class="area-title-production">{Area}</h1>
      {animation ? (
        <div >
          <div class="row" id="area-title-overflow">

            <div class="col-sm-5" id="Purchase_dashboard">
              <h1>NEW REQUESTS</h1>
              <table className="table table-striped" id="Purchase_dashboard_table">
                <thead>
                  <tr>
                    <th>Request Date</th>
                    <th>Request By</th>
                    <th>Item Description</th>
                    <th>Qty</th>
                    <th id="mobileView">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {newrequests.map((val, index) => {
                    return (

                      <tr key={val.ID} >
                        <td>{val.Requested_Date ? val.Requested_Date.slice(0, 10) : ""}</td>
                        <td>{val.Name}</td>
                        <td className="truncate-hover" title={val.Item_Desc || ""}>
                          {(() => {
                            const text = val.Item_Desc || "";
                            const urlRegex = /(https?:\/\/[^\s]+)/g;
                            const parts = text.split(urlRegex);

                            return parts.map((part, idx) => {
                              if (urlRegex.test(part)) {
                                const display = part.length > 30 ? part.slice(0, 30) + "…" : part;
                                return (
                                  <a
                                    key={idx}
                                    href={part}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#007bff",
                                      textDecoration: "underline",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    {display}
                                  </a>
                                );
                              }
                              return <span key={idx}>{part}</span>;
                            });
                          })()}
                        </td>
                        <td>{val.Qty}</td>

                        <td id="mobileView">{val.Status}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div class="col-sm-5" id="Purchase_dashboard">
              <h1>APPROVED ORDERS</h1>
              <table className="table table-striped" id="Purchase_dashboard_table">
                <thead>
                  <tr>
                    <th>Request Date</th>
                    <th>Item Description</th>
                    <th>Qty</th>
                    <th>Required Before</th>
                    <th id="mobileView">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {awaitingorder.map((val, index) => {
                    return (

                      <tr key={val.ID} >
                        <td>{val.Requested_Date ? val.Requested_Date.slice(0, 10) : ""}</td>
                        <td className="truncate-hover" title={val.Item_Desc || ""}>
                          {(() => {
                            const text = val.Item_Desc || "";
                            const urlRegex = /(https?:\/\/[^\s]+)/g;
                            const parts = text.split(urlRegex);

                            return parts.map((part, idx) => {
                              if (urlRegex.test(part)) {
                                const display = part.length > 30 ? part.slice(0, 30) + "…" : part;
                                return (
                                  <a
                                    key={idx}
                                    href={part}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#007bff",
                                      textDecoration: "underline",
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    {display}
                                  </a>
                                );
                              }
                              return <span key={idx}>{part}</span>;
                            });
                          })()}
                        </td>
                        <td>{val.Qty}</td>
                        <td>{val.Required_Before ? val.Required_Before.slice(0, 10) : ""}</td>


                        <td id="mobileView">{val.Status}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div class="col-sm-1">
            </div>
          </div>
        </div>
      ) : null}
      {All_Request ? <All_Purchase_Requests /> : null}
      {New_Request ? <PurchaseForm /> : null}

    </div>

  );
}

export default Purchase_dashboard;